import { USERS } from "../../lib/users";

const NAMES = Object.fromEntries(USERS.map(u => [u.employeeId, u.name]));

export const actorName = (id) => (id === "system" ? "System" : NAMES[id] ? `${NAMES[id]} (${id})` : id || "unknown");
